import { useEffect, useState } from "react"

export default function useSessionState(initialValue, name) {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        const storedValue = sessionStorage.getItem(`field.${name}`);
        if (storedValue) {
            setValue(JSON.parse(storedValue));
        }
    }, []);

    useEffect(() => {
        sessionStorage.setItem(`field.${name}`, JSON.stringify(value));
    }, [value]);

    return [value, setValue];
}